
import React from 'react';
import { Skeleton } from '../../Skeleton';

const MedwikiChannelLoader = () => {
  return (
    <>
      <div className="w-100 medwikiChannelBox overflow-hidden rounded-3 shadow text-center mb-5">
        <div className="medwikiChannelBoxIn d-flex justify-conntent-between">
          <div className="medwikiChannelPart d-flex justify-content-start align-items-center py-3 pe-20 ps-3">
            <div className="medwikiChannelPic position-relative overflow-hidden rounded-circle bg-white d-inline-flex justify-content-center align-items-center p-2">
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                className={`mw-100 mh-100 w-auto h-auto`}
              />
            </div>
            <div className="medwikiChannelName ps-3 text-start">
              <h4 className={`fs-4 fw-medium text-black line-clamp-2`}>
                <Skeleton variant="text" width="100%" height="100%" />
              </h4>
            </div>
          </div>
          <div className="followBtn bg-secondary position-relative d-flex align-items-center justify-content-center pe-3 ps-3 ">
            <div className="followBtnIn z-1 position-relative d-flex align-items-center gap-1">
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedwikiChannelLoader;
